// Contexte tenant — quel "domaine/porte d'entrée" est actif pour la session
import React, { createContext, useContext, useMemo, useEffect } from 'react';
import { resolveTenant } from '../config/domains';

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  // Résolu une seule fois : le domaine ne change pas en cours de session
  const tenant = useMemo(() => resolveTenant(), []);

  // Habillage PWA par porte d'entrée : manifest (icône/app installable) + titre
  useEffect(() => {
    if (tenant.manifest) {
      const lien = document.querySelector('link[rel="manifest"]');
      if (lien) lien.setAttribute('href', tenant.manifest);
    }
    if (tenant.titre) {
      document.title = tenant.titre;
    }
  }, [tenant]);

  return (
    <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
  );
}

export function useTenant() {
  const tenant = useContext(TenantContext);
  return tenant || resolveTenant();
}
